import Main from '../components/main'

export default [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home/index.vue')
  },
  {
    path: '/Login',
    name: 'login',
    component: () => import('../views/Login/login.vue')
  },
  {
    path: '/Register',
    name: 'register',
    component: () => import('../views/Login/register.vue')
  },
  {
    path: '/Forward',
    name: 'forward',
    component: () => import('../views/Login/forward.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: Main,
    children: [
      {
        path: 'workbench',
        name: 'workbench',
        component: () => import('../views/Admin/workbench/workbench')
      },
      {
        path: 'productTemplate',
        name: 'product_template',
        component: () => import('../views/Admin/productTemplate/productTemplate')
      }
    ]
  },
  {
    path: '/admin',
    name: 'admin',
    component: Main,
    children: [
      {
        path: 'orderArtical',
        name: 'order_artical',
        component: () => import('../views/Admin/orderArtical/orderArtical')
      }
    ]
  },
  {
    path: '/order',
    name: 'order',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'order_list',
        component: () => import('../views/Admin/order/order')
      },
      {
        path: 'detail/:id',
        name: 'order_detail',
        component: () => import('../views/Admin/order/detail')
      },
      {
        path: 'detail/:id',
        name: 'order_pay',
        component: () => import('../views/Admin/order/pay')
      },
      {
        path: 'detail/:id',
        name: 'order_refund',
        component: () => import('../views/Admin/order/refund')
      },
      {
        path: 'detail/:id',
        name: 'order_evaluate',
        component: () => import('../views/Admin/order/evaluate')
      },
      {
        path: 'detail/:id',
        name: 'order_complaint',
        component: () => import('../views/Admin/order/complaint')
      }
    ]
  },
  {
    path: '/setting',
    name: 'user_setting',
    component: Main,
    children: [
      {
        path: 'index',
        name: 'setting',
        component: () => import('../views/Setting/setting')
      }
    ]
  },
  {
    path: '/wallet',
    name: 'user_wallet',
    component: Main,
    children: [
      {
        path: 'index',
        name: 'wallet_index',
        component: () => import('../views/Wallet/index')
      },
      {
        path: 'invite',
        name: 'invite_code',
        component: () => import('../views/Wallet/invite')
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('../views/Wallet/coupon')
      },
      {
        path: 'recharge',
        name: 'recharge',
        component: () => import('../views/Wallet/recharge')
      },
      {
        path: 'withdrawal',
        name: 'withdrawal',
        component: () => import('../views/Wallet/withdrawal')
      }
    ]
  },
  {
    path: '/message',
    name: 'user_message',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'message',
        component: () => import('../views/Message/list')
      },
      {
        path: 'detail/:id',
        name: 'message_detail',
        component: () => import('../views/Message/detail')
      }
    ]
  },
  {
    path: '/evaluate',
    name: 'user_evaluate',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'evaluate',
        component: () => import('../views/Evaluate/list')
      }
    ]
  },
  {
    path: '/user',
    name: 'user_center',
    component: () => import('../views/User/center')
  },
  {
    path: '/security',
    name: 'user_security',
    component: () => import('../views/User/security')
  },
  {
    path: '/setPassword',
    name: 'user_setPassword',
    component: () => import('../views/User/setPassword')
  },
  {
    path: '/editPhone',
    name: 'user_editPhone',
    component: () => import('../views/User/editPhone')
  },
  {
    path: '/setPayPassword',
    name: 'user_setPayPassword',
    component: () => import('../views/User/setPayPassword')
  },
  {
    path: '/place',
    name: 'place',
    component: () => import('../views/Order/place')
  },
]
